import Tools from './../components/tools';
import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Landing {
    constructor() {
        // Home
        gsap.registerPlugin(ScrollTrigger);

        this.header();
        this.studio();
        this.services();
        this.savoir();
        this.equipe();
        this.hovers();
        this.player();
        this.slider('.location__slider', '.location__imageItem', false, true);
        this.slider('.eco__slider', '.eco__imageItem', false, true);
        this.slider('.space__slider', '.space__imageItem', true, false);
        this.location();
        this.eco();
        this.space();
    }

    header() {
        const slider = document.querySelector('.header__slider');
        if (slider) {
            tns({
                container: slider,
                items: 1,
                slideBy: 'page',
                controls: false,
                loop: false,
                speed: 850,
            });
        }
    }

    studio() {
        const img = document.querySelector('.page-template-landing section .studio__background');
        if (img) {
            gsap.to(
                img,
                {
                    scrollTrigger: {
                        trigger: img,
                        start: 'top 66%'
                    },
                    ease: "power4.out",
                    duration: 1.35,
                    scale: 1,
                    opacity: 1,
                }
            );
        }

        const map = document.querySelector('.studio__map');
        if(map) {
            map.querySelectorAll('.map__group').forEach((marker) => {
                marker.addEventListener('click', () => {
                    document.querySelector(`.studio__mapContent[data-location="${marker.dataset.location}"]`).classList.add('js-visible');
                });
            });

            document.querySelectorAll('.studio__mapClose').forEach((btn) => {
                btn.addEventListener('click', () => {
                    btn.parentElement.classList.remove('js-visible');
                });
            });
        }
    }

    services() {
        const slider = document.querySelector('.service__container');
        if (slider) {
            tns({
                container: slider,
                items: 1,
                controls: false,
                loop: false,
                navPosition: 'bottom',
                speed: 850,
                gutter: 30,
                responsive: {
                    768: {
                        items: 2,
                    },
                    1024: {
                        items: 4,
                    }
                }
            });
        }

        const cols = document.querySelectorAll('.service__container .col__content');
        if (cols.length > 0) {
            gsap.to(
                cols,
                {
                    scrollTrigger: {
                        trigger: document.querySelector('.service__container'),
                        start: 'top 66%'
                    },
                    ease: "power4.out",
                    duration: 1.35,
                    y: 0,
                    opacity: 1,
                    stagger: 0.1,
                }
            );
        }

        const elts = document.querySelectorAll('.col__content');
        if (elts.length > 0) {
            elts.forEach((elt) => {
                elt.addEventListener('click', () => {
                    if (document.querySelector(`.service__popin[data-tab="${elt.dataset.id}"]`)) {
                        document.querySelector(`.service__popin[data-tab="${elt.dataset.id}"]`).classList.add('js-visible');
                    }
                });
            });
        }

        const btns = document.querySelectorAll('.service__popinClose');
        if (btns.length > 0) {
            btns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    btn.parentElement.parentElement.parentElement.classList.remove('js-visible');
                });
            });
        }
    }

    equipe() {
        const img = document.querySelector('.page-template-landing section .equipe__background');
        if (img) {
            gsap.to(
                img,
                {
                    scrollTrigger: {
                        trigger: img,
                        start: 'top 66%'
                    },
                    ease: "power4.out",
                    duration: 1.35,
                    scale: 1,
                    opacity: 1,
                }
            );
        }
    }

    savoir() {
        const items = document.querySelectorAll('.savoir .cards-container .card');
        if (items.length > 0) {
            items.forEach((item) => {
                gsap.to(
                    item.querySelector('.figure video'),
                    {
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 66%'
                        },
                        ease: "power4.out",
                        duration: 1.35,
                        scale: 1,
                        opacity: 1,
                    }
                );

                gsap.to(
                    item.querySelector('.text-container'),
                    {
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 50%'
                        },
                        ease: "power4.out",
                        duration: 1.35,
                        y: 0,
                        opacity: 1,
                    }
                );
            });
        }
    }

    hovers() {
        const items = document.querySelectorAll('.savoir .cards-container .card');
        if (items.length > 0) {
            items.forEach((item) => {
                item.querySelector('.figure').addEventListener('mouseenter', () => {
                    item.querySelector('video').play();
                });

                item.querySelector('.figure').addEventListener('mouseleave', () => {
                    item.querySelector('video').pause();
                });
            });
        }
    }

    player() {
        const items = document.querySelectorAll('.savoir .cards-container .card .figure');
        if (items.length > 0) {
            items.forEach((item) => {
                item.addEventListener('click', () => {
                    document.querySelector('aside.popin-video').classList.add('visible');
                    document.querySelector('aside.popin-video iframe').src = `${item.dataset.id}?fallback=true`;
                });
            });

            const popin = document.querySelector('.popin-video');
            if (popin) {
                popin.querySelector('.close').addEventListener('click', () => {
                    document.querySelector('aside.popin-video').classList.remove('visible');
                    document.querySelector('aside.popin-video iframe').src = '';
                });
            }
        }
    }

    slider(element, image, hasControls, hasNav) {
        const slider = document.querySelector(element);
        if (slider) {
            const elt = tns({
                container: slider,
                items: 1,
                slideBy: 'page',
                controls: hasControls,
                nav: hasNav,
                navPosition: 'bottom',
                loop: false,
                speed: 850,
            });

            elt.events.on('transitionStart', function (info) {
                if (info.index < info.indexCached) {
                    document.querySelectorAll(image)[info.index].style.transitionDuration = '0s';
                    document.querySelectorAll(image)[info.index].classList.add('js-visible');
                    document.querySelectorAll(image)[info.indexCached].classList.remove('js-visible');
                    document.querySelectorAll(image)[info.indexCached].style.zIndex = '2';
                    setTimeout(() => {
                        document.querySelectorAll(image)[info.index].style.transitionDuration = '';
                        document.querySelectorAll(image)[info.indexCached].style.zIndex = '';
                    }, 1000);
                } else {
                    document.querySelectorAll(image)[info.index].classList.add('js-visible');
                    setTimeout(() => {
                        document.querySelectorAll(image)[info.indexCached].classList.remove('js-visible');
                    }, 1000);
                }
            });
        }
    }

    location() {
        const elt = document.querySelector('.page-template-landing section .location__image');
        if (elt) {
            gsap.to(
                elt,
                {
                    scrollTrigger: {
                        trigger: document.querySelector('.page-template-landing section .location'),
                        start: 'top 66%'
                    },
                    ease: "power4.out",
                    duration: 1.35,
                    y: 0,
                    opacity: 1,
                }
            );
        }
    }

    eco() {
        const elt = document.querySelector('.page-template-landing section .eco__image');
        if (elt) {
            gsap.to(
                elt,
                {
                    scrollTrigger: {
                        trigger: document.querySelector('.page-template-landing section .eco'),
                        start: 'top 66%'
                    },
                    ease: "power4.out",
                    duration: 1.35,
                    scale: 1,
                    opacity: 1,
                }
            );
        }
    }

    space() {
        const elt = document.querySelector('.page-template-landing section .space__image');
        if (elt) {
            gsap.to(
                elt,
                {
                    scrollTrigger: {
                        trigger: document.querySelector('.page-template-landing section .space'),
                        start: 'top 66%'
                    },
                    ease: "power4.out",
                    duration: 1.35,
                    scale: 1,
                    opacity: 1,
                }
            );
        }
    }
}